// extracted by css-extract-rspack-plugin
export default {"labelStack":"GHigo"};